/**
 * @file HomeFooter 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext} from 'react';
import {useHistory} from 'react-router-dom';
import Iconfont from '~/component/Iconfont';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

function HomeFooter() {
    const history = useHistory();
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    function handlePrint() {
        window.print();
    }

    function handleEnter() {
        history.push('/contact/investor');
    }

    return (
        <div className="home-footer-container">
            <div className="home-footer-content">

                {
                    !isMobile && (
                        <div
                            className="print"
                            tabIndex={0}
                            role="button"
                            onClick={handlePrint}
                        >
                            <Iconfont type="icondayinji" />
                            <div>Print Page</div>
                        </div>
                    )
                }

                <div
                    className={isMobile ? 'email-m' : 'email'}
                    role="button"
                    onClick={handleEnter}
                    tabIndex={0}
                >
                    <Iconfont type="iconyouxiang" className="iconyouxiang" />
                    <div className="email-alrets-m">Email Alerts</div>
                </div>
            </div>
        </div>
    );
}

export default HomeFooter;
